<template>
  <div v-if="showList">
    <h1>Kontakte</h1>
    <table class="table table-sm table-hover clickable contactlist">
      <thead>
      <tr>
<!--        <th scope="col">#</th>-->
        <th class="d-md-none" scope="col">Kontakt</th>
        <th class="d-none d-md-table-cell" scope="col">Name</th>
        <th class="d-none d-md-table-cell" scope="col">Ort</th>
        <th class="d-none d-md-table-cell" scope="col">E-Mail</th>
        <th class="d-none d-md-table-cell" scope="col">Vertrag mit</th>
      </tr>
      </thead>
      <tbody>
      <tr
          v-for="entry in entries"
          :key="entry.contactId"
          @click="cruElement(entry.contactId)">
<!--        <th scope="row">{{ entry.contactId }}</th>-->
        <td>
          <img v-if="entry.warning" src="@/assets/images/icon-err.svg"/>
          <img v-else-if="entry.contactType == 0" src="@/assets/images/icon-owner.svg"/>
          <img v-else-if="entry.contactType == 1" src="@/assets/images/icon-farmer.svg"/>
          <img v-else-if="entry.contactType == 2" src="@/assets/images/icon-regrater.svg"/>
          <b>{{ entry.name }}</b>
          <span class="d-md-none">, {{ entry.city }}</span>
          <span v-if="entry.contractRegraters" class="d-md-none"><br/>Vertrag mit {{ entry.contractRegraters }}</span>
        </td>
        <td class="d-none d-md-table-cell">{{ entry.city }}</td>
        <td class="d-none d-md-table-cell">{{ entry.email }}</td>
        <td class="d-none d-md-table-cell">{{ entry.contractRegraters }}</td>
      </tr>
      </tbody>
    </table>
  </div>
  <contact-editor v-if="formOpened" :element-id="elementId" @closeForm="closeForm"/>
  <app-btn-back class="pt-2"/>
  <app-btn-add v-if="!formOpened" @click="openForm"/>
</template>

<script>
import ContactEditor from "@/components/ContactEditor";

export default {
  name: "ContactPage",
  components: {ContactEditor},
  data() {
    return {
      showList: true,
      formOpened: false,
      elementId: null,
      list: null,
      entries: [],
      detailsRelations: [],
    }
  },
  async created() {
    await this.$store.dispatch('initItems', { entityName: 'regrater' })
    await this.$store.dispatch('getItemList', { entityName:'contact' })
    this.detailsRelations = await this.$store.dispatch('getItemList',
        { entityName:'contact', method:'contactDetailsRelations', returnData: true })
    this.enrichList()
  },
  methods: {
    getListItems(){
      return this.$store.state.contact
    },
    cruElement(id) {
      this.elementId = id
      this.showList = false
      this.formOpened = true
    },
    openForm() {
      this.showList = false
      this.formOpened = true
    },
    closeForm() {
      this.formOpened = false
      this.showList = true
      this.elementId = null
    },
    enrichList() {
      const entries = this.$store.state.contact
      let contactType
      let name
      let details
      let contractRegraters
      let regraterName

      entries.map((entry) => {
        if (entry.contactType === contactType && entry.name.trim() === name) {
          // mark duplicate
          entry.warning = true
        }
        contactType = entry.contactType
        name = entry.name.trim()

        details = this.detailsRelations.filter(e => e.contactId === entry.contactId)
        contractRegraters = []
        if (details) {
          for (let detail of details) {
            regraterName = this.$store.state.regrater.find(r => r.contactId === detail.regraterId).name
            if (contractRegraters.indexOf(regraterName) === -1) {
              contractRegraters.push(regraterName)
            }
          }
          entry.contractRegraters = contractRegraters.join(', ')
        }
      })
      this.entries = entries
    },
  }
}
</script>

<style scoped>

</style>